import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "n-icon-1_camera_and_episodes",
  "use": "n-icon-1_camera_and_episodes-usage",
  "viewBox": "0 0 50 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 50 40\" id=\"n-icon-1_camera_and_episodes\"><rect width=\"24\" height=\"40\" fill=\"#66809F\" fill-opacity=\".15\" rx=\"2\" /><rect width=\"24\" height=\"40\" x=\"26\" fill=\"#66809F\" fill-opacity=\".15\" rx=\"2\" /><path fill=\"#fff\" d=\"M42.726 19.102a1.042 1.042 0 0 1 0 1.796l-7.322 4.312a1.042 1.042 0 0 1-1.57-.898v-8.624c0-.806.875-1.306 1.57-.898l7.322 4.313Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol